import Bubble from '@components/Bubble';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

interface ICopyOnClick {
  className?: string;
  valueForCopy: string;
  hintText: string;
  children: JSX.Element;
}

const CopyOnClick = ({
  className,
  valueForCopy,
  hintText,
  children,
}: ICopyOnClick) => {
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    if (isCopied) {
      setTimeout(() => {
        setIsCopied(false);
      }, 3000);
    }
  }, [isCopied]);

  const onClick = async e => {
    e.stopPropagation();

    await navigator.clipboard.writeText(valueForCopy);

    setIsCopied(true);
  };
  return (
    <StyledBubble
      className={className}
      text={isCopied ? 'Cкопировано' : hintText}
      placement="bottom"
    >
      <StyledCopyOnClick onClick={onClick}>{children}</StyledCopyOnClick>
    </StyledBubble>
  );
};

const StyledCopyOnClick = styled.div`
  display: flex;
  cursor: pointer;
  color: #919499;
  font-size: 12px;
  text-transform: uppercase;
`;

const StyledBubble = styled(Bubble)`
  & > div {
    width: 100%;
  }
`;

export default CopyOnClick;
